import type { AgentsListResult } from "../types.ts";

/** Pick an agent id that exists in agents.list (gateway-visible agents). */
export function resolveAgentsTabAgentId(state: {
  agentsSelectedId: string | null;
  agentsList: AgentsListResult | null;
}): string | null {
  const ids = new Set(state.agentsList?.agents?.map((entry) => entry.id) ?? []);
  if (ids.size === 0) {
    return null;
  }
  for (const candidate of [
    state.agentsSelectedId,
    state.agentsList?.defaultId,
    state.agentsList?.agents?.[0]?.id,
  ]) {
    if (candidate && ids.has(candidate)) {
      return candidate;
    }
  }
  return null;
}
